import { Injectable } from '@angular/core';
import { Observable as Observable$1 } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
var PushNotificationOptions = (function () {
    function PushNotificationOptions() {
        this.dir = ('auto');
        this.lang = 'en-US';
        this.renotify = false;
        this.sticky = false;
        this.noscreen = false;
        this.silent = true;
    }
    return PushNotificationOptions;
}());
var PushNotificationService = (function () {
    function PushNotificationService() {
    }
    /**
     * @return {?}
     */
    PushNotificationService.prototype.checkCompatibility = function () {
        return !!('Notification' in window);
    };
    /**
     * @return {?}
     */
    PushNotificationService.prototype.requestPermission = function () {
        return (Observable$1.fromPromise(Notification.requestPermission()));
    };
    /**
     * @param {?} permission
     * @return {?}
     */
    PushNotificationService.prototype.isPermissionGranted = function (permission) {
        return permission === 'granted';
    };
    /**
     * @param {?} title
     * @param {?=} options
     * @return {?}
     */
    PushNotificationService.prototype.create = function (title, options) {
        var _this = this;
        return new Observable$1(function (obs) {
            if (!_this.checkCompatibility()) {
                var /** @type {?} */ err = 'Notifications are not available in this browser.';
                console.error(err);
                obs.error(err);
                obs.complete();
            }
            _this.requestPermission().subscribe(function (perm) {
                if (!_this.isPermissionGranted(perm)) {
                    var /** @type {?} */ err = 'The user hasn\'t granted you permission to send push notifications';
                    console.error(err);
                    obs.error(err);
                    obs.complete();
                }
                else {
                    var /** @type {?} */ notif_1 = new Notification(title, options);
                    notif_1.onshow = function (e) {
                        obs.next({ notification: notif_1, event: e });
                    };
                    notif_1.onclick = function (e) {
                        obs.next({ notification: notif_1, event: e });
                    };
                    notif_1.onerror = function (e) {
                        obs.error({ notification: notif_1, event: e });
                    };
                    notif_1.onclose = function (e) {
                        obs.next({ notification: notif_1, event: e });
                    };
                }
            });
        });
    };
    return PushNotificationService;
}());
PushNotificationService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
PushNotificationService.ctorParameters = function () { return []; };
/**
 * Generated bundle index. Do not edit.
 */
export { PushNotificationOptions, PushNotificationService };
//# sourceMappingURL=ngx-push-notifications.es5.js.map



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/ngx-push-notifications/ngx-push-notifications.es5.js
// module id = ../../../../ngx-push-notifications/ngx-push-notifications.es5.js
// module chunks = common